export const en = {
    time_limit_access_exceeded_contact_responsible:
        'The time limit to access the page has been exceeded, please contact the responsible person to generate a new link if necessary',
    url_not_found: 'URL not found',
    ensure_url_entered_is_correct_with_responsible:
        'Please ensure that the URL entered is correct with the responsible person',
    temporary_link_expired: 'Temporary link expired	',
};
